/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { VideoMeetingProvider } from './videoMeetingProvider';

/**
 * Which video meeting provider to use for slots of this event kind. When None, falls back to `appointment_integrations.default_video_provider`. This is the source of truth for NEW slots; once a slot is provisioned the provider is stamped onto the slot and never re-resolved (see §10.3 of the oral-exam-livekit-v1 spec).
 */
export type EventKindVideoProvider = VideoMeetingProvider | null;
